import { CreditNotesPage } from './CreditNotesPage';

// Credit Notes are no longer split by B2C / B2B — a single merged list shows both,
// with a Service column and a service-type picker on the Generate form.
export function CreditNotesUnifiedPage() {
  return <CreditNotesPage />;
}
